





































import { Component, Vue } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { IMessage } from '@/store/alert/types';
import { LoginState, User } from '@/store/login/types';
import Alert from '@/components/Alert.vue';
import Cards from '@/components/Cards.vue';
import Input from '@/components/Input.vue';
import PasswordHelper from '../helpers/PasswordHelper';

const namespace: string = 'login';

@Component({
  components: {
    Alert,
    Cards,
    Input,
  },
})
export default class Account extends Vue {
  @Action('password', { namespace }) private password: (
    user: User,
  ) => Promise<undefined>;
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @State('login') private loginState?: LoginState;
  private user: User = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  };

  private onChangePassword(oldPassword: string, newPassword: string) {
    if (
      this.user.oldPassword! !== '' &&
      this.user.newPassword! !== '' &&
      this.user.confirmPassword! !== ''
    ) {
      if (this.user.newPassword! === this.user.confirmPassword!) {
        if (PasswordHelper.isPasswordSecure(this.user.newPassword)) {
          this.password(this.user)
            .then(() => {
              this.user.oldPassword = '';
              this.user.newPassword = '';
              this.user.confirmPassword = '';
            })
            .catch(() => {});
        } else {
          this.alert({
            prefix: 'INPUT_',
            error: 'NOT_SECURE',
          });
        }
      } else {
        this.alert({
          prefix: 'INPUT_',
          error: 'NOT_SAME',
        });
      }
    } else {
      this.alert({
        prefix: 'INPUT_',
        error: 'EMPTY',
      });
    }
  }
}
